
import React from 'react';

export const AboutSection: React.FC = () => {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            <strong>關於焯峯工程</strong>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            專業可靠的香港工程服務夥伴，為您提供全方位的<strong>屋宇署工程解決方案</strong>
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-6">專業工程服務公司</h3>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              焯峯工程有限公司是一家專業的香港工程服務公司，專門提供屋宇署相關的工程監督和申報服務。我們擁有豐富的經驗和專業資質，致力於為客戶提供高質量的<strong>工程技術服務</strong>，確保所有工程項目符合香港屋宇署的法規要求。
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              我們的專業團隊深諳香港建築法規，能夠為客戶提供從<strong>村屋僭建物申報</strong>到<strong>適任技術人員註冊</strong>的全方位服務，讓您的工程項目順利進行。
            </p>
            <div className="grid grid-cols-2 gap-6">
              <div className="text-center">
                <div className="text-3xl font-bold text-red-600 mb-2">10+</div>
                <div className="text-gray-600">年專業經驗</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-red-600 mb-2">500+</div>
                <div className="text-gray-600">成功案例</div>
              </div>
            </div>
          </div>
          
          <div className="flex items-center justify-center">
            <div className="bg-white rounded-2xl shadow-lg p-12 text-center w-full max-w-md">
              <h4 className="text-xl font-bold text-gray-900 mb-2">焯峯工程有限公司</h4>
              <p className="text-gray-600">專業 · 可靠 · 合規</p>
              <div className="mt-6 pt-6 border-t border-gray-200">
                <p className="text-sm text-gray-500">香港屋宇署認可</p>
                <p className="text-sm text-gray-500">工程監督服務</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};